import * as types from "./mutation-type";

export default {
  [types.SET_ADDRESS](state, payload) {
    state.address = payload
  },

  [types.SET_MAIN_ADDRESS](state, payload) {
    state.mainAddress = payload
  }
}
